module.exports = "\n<div class=\"container -clients-add\">\n    <h1>Ajouter un membre</h1>\n\n    <tab-set>\n        <tab :header=\"'Individu'\">\n            <add-individual></add-individual>\n        </tab>\n        <tab :header=\"'Famille'\">\n            <add-family></add-family>\n        </tab>\n        <tab :header=\"'Personne morale'\">\n            <add-moral-person></add-moral-person>\n        </tab>\n    </tab-set>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ClientsAdd.vue
// module id = 500
// module chunks = 0